import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggedOutComponent } from './logged-out.component';

@NgModule({
  declarations: [LoggedOutComponent],
  imports: [CommonModule],
})
export class LoggedOutModule {}
